import React, { useState, useEffect } from "react";
import "./MessageInput.css";
import { useChat } from "../Layout/ChatProvider/ChatProvider";
import { getUsersByCompany } from "../../../services/api";
import { User } from "../../../types/User";
import sendIcon from "../../../assets/send-icon.png";

// Fictive "מנהל מערכת" user
const defaultUser: User = {
    id: -1,
    email: "admin@system.com",
    userId: "0",
    groupId: 0,
    company_id: 0,
    first_name: "",
    last_name: "",
    job_title_id: "מנהל מערכת",
    phone_number: 0
};

const MessageInput: React.FC = () => {
    const [message, setMessage] = useState("");
    const [users, setUsers] = useState<User[]>([defaultUser]);
    const [selectedUser, setSelectedUser] = useState<string>(String(defaultUser.id)); // Default to "מנהל מערכת"
    const { companyId, sendMessage, executeRun } = useChat(); // ✅ Get companyId from context

    useEffect(() => {
        if (!companyId) {
            return;
        }
        fetchUsers(companyId);
    }, [companyId]);

    const fetchUsers = async (companyId: string) => {
        try {
            const fetchedUsers = await getUsersByCompany(companyId);
            const updatedUsers = [defaultUser, ...fetchedUsers];
            setUsers(updatedUsers);
            // Ensure "מנהל מערכת" remains selected if no other selection was made
            if (!selectedUser || selectedUser === String(defaultUser.id)) {
                setSelectedUser(String(defaultUser.id));
            }
        } catch (error) {
            console.error("❌ Error fetching users:", error);
        }
    };

    const handleSend = async () => {
        if (message.trim()) {
            if (companyId) {
                await sendMessage(companyId, `${message}`);
            }
            setMessage("");
        }
    };

    const handleRun = async () => {
        if (companyId) {
            await handleSend();
            await executeRun(companyId);
        }
        setMessage("");
    };

    const handleKeyDown = async (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === "Enter") {
            if (e.shiftKey) {
                e.preventDefault();
                setMessage((prev) => prev + "\n");
            } else if (e.ctrlKey || e.metaKey) {
                e.preventDefault();
                await handleSend();
                handleRun();
            } else {
                e.preventDefault();
                await handleSend();
            }
        }
    };

    return (
        <div className="message-input-container">
            <button className="run-button" onClick={handleRun}>
                <img src={sendIcon} alt="send" className="send-icon" />
            </button>
            <textarea
                className="message-input"
                placeholder="כתיבת הודעה"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={handleKeyDown}
            />
        </div>
    );
};

export default MessageInput;
